module.exports = __webpack_public_path__ + "static/media/oval-white.13e65bd0.svg";